import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './../langs/messages.js';

Vue.use(VueI18n);

const locale = document.documentElement.lang.substr(0, 2);

export default new VueI18n({locale, messages});


